import React from 'react';
import { Button, Tooltip, Row } from 'antd';
import { FormField } from 'common';
import {
  CORPORATIONS_INITIAL_VALUES,
  requiredWarn,
  getCurrentSectionNo,
  getCurrentCorporation,
  EMPTY_VALUE,
  XOSIMAGE_FORM,
} from 'pages/XosImages';
import { getFormValues } from 'redux-form';
import { AppState } from 'store';
import { useSelector } from 'react-redux';
import styles from '../Individuals/Individuals.module.scss';

const ButtonGroup = Button.Group;
const addLimit = 2;
const removeLimit = 1;

const Corporation: any = ({
  fields,
  meta: { error },
  handleFieldFocus,
}: any) => {
  const formValues = useSelector((state: AppState) =>
    getFormValues(XOSIMAGE_FORM)(state),
  );

  const requiredNameField = React.useCallback((value, values, _, fieldName) => {
    const sectionNo = getCurrentSectionNo(fieldName);
    const corpNo = fieldName.substring(22, 23);
    const currentCorp = getCurrentCorporation(values, sectionNo, corpNo);
    const { bankruptcySearch, patriotSearch } = currentCorp || {
      bankruptcySearch: EMPTY_VALUE,
      patriotSearch: EMPTY_VALUE,
    };
    if (value) return undefined;
    if (bankruptcySearch || patriotSearch) return requiredWarn;
    return undefined;
  }, []);

  const requiredCheckBox = React.useCallback((value, values, _, fieldName) => {
    const sectionNo = getCurrentSectionNo(fieldName);
    const corpNo = fieldName.substring(22, 23);
    const currentInd = getCurrentCorporation(values, sectionNo, corpNo);
    const { corporationName, bankruptcySearch, patriotSearch } = currentInd || {
      corporationName: EMPTY_VALUE,
      bankruptcySearch: false,
      patriotSearch: false,
    };
    if (value || bankruptcySearch || patriotSearch) return undefined;
    if (corporationName) return true;
    return undefined;
  }, []);

  return (
    <>
      {fields.map((corporation: any, index: number) => {
        const sectionNo = getCurrentSectionNo(corporation);
        const corpNo = corporation.substring(22, 23);
        const currentInd = getCurrentCorporation(
          formValues,
          `${sectionNo}`,
          corpNo,
        );
        const { corporationName, bankruptcySearch, patriotSearch } =
          currentInd || {
            corporationName: EMPTY_VALUE,
            bankruptcySearch: false,
            patriotSearch: false,
          };

        const displayCheckboxWarn =
          !bankruptcySearch && !patriotSearch && corporationName;

        return (
          <React.Fragment key={index}>
            <Row type="flex">
              <FormField
                key={index}
                onFocus={handleFieldFocus}
                label={index === 0 ? 'Corp Name' : ''}
                name={`${corporation}.corporationName`}
                validate={[requiredNameField]}
                addonAfter={
                  <ButtonGroup>
                    <Tooltip title={`Remove Corporation Name`}>
                      <Button
                        type="link"
                        size="small"
                        icon="minus"
                        onClick={() => fields.remove(index)}
                        disabled={fields.length === removeLimit}
                      />
                    </Tooltip>
                    {fields.length - 1 === index && (
                      <Tooltip
                        title={`Add Corporation Name (the limit is ${addLimit})`}
                      >
                        <Button
                          type="link"
                          size="small"
                          icon="plus"
                          onClick={() =>
                            fields.push(CORPORATIONS_INITIAL_VALUES)
                          }
                          disabled={fields.length >= addLimit}
                        />
                      </Tooltip>
                    )}
                  </ButtonGroup>
                }
              />
            </Row>
          </React.Fragment>
        );
      })}
    </>
  );
};

export default Corporation;
